import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';
import {
  SignUpVerify,
  SignUpContact,
  SignUpRedirect,
  SignUpInfo,
  SignUpEmail
} from '@hero/organisms';

import AuthLayout from '../layout';

const MotionDiv = styled(motion.div)`
  width: fit-content;

  ${DEVICE.mobile.max} {
    width: 100%;
  }
`;
export default function SignUpPage() {
  const [activeStep, setActiveStep] = useState(0);
  const [signUpData, setSignUpData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    password: ''
  });

  const steps = [
    {
      id: 'create-account',
      label: 'Create Account',
      stepIndex: 0
    },
    {
      id: 'contact-info',
      label: 'Contact Info',
      stepIndex: 1
    },
    {
      id: 'company-info',
      label: 'Company Info',
      stepIndex: 2
    }
  ];

  const signUpSteps = [SignUpEmail, SignUpVerify, SignUpContact, SignUpInfo, SignUpRedirect];

  const Component = signUpSteps[activeStep];

  return (
    <AuthLayout steps={activeStep < 3 && steps} activeStep={activeStep}>
      <AnimatePresence initial={false} mode="wait">
        <MotionDiv
          key={activeStep}
          variants={{
            initial: { opacity: 0 },
            enter: { opacity: 1, transition: { duration: 0.4 } },
            exit: { opacity: 0, transition: { duration: 0.4 } }
          }}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <Component
            signUpData={signUpData}
            setSignUpData={setSignUpData}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
          />
        </MotionDiv>
      </AnimatePresence>
    </AuthLayout>
  );
}
